import { HeaderWrapper } from "./styles";
import { LanguageSelect } from "views/mobile/components/LanguageSelect";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import React from "react";

export const WaitingRoomHeader = ({ theme }) => {
	const history = useHistory();
	const { t } = useTranslation("waitingRoom");

	const handleExit = () => {
		history.push("/");
	};

	return (
		<>
			<HeaderWrapper theme={theme}>
				<div className='header-info' onClick={handleExit}>
					<img 
						className={theme.iconSize === 'big'
							? 'big-header-icon' 
							: 'header-icon'
						} 
						src={theme.headerIcon} 
					/>
					<h1>{t("title")}</h1>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
					}}
				>
					<LanguageSelect />
				</div>
			</HeaderWrapper>
		</>
	);
};
